<owl-carousel-o [options]="customOptions" >
    <ng-container *ngFor="let slide  of slidesStore">
    <ng-template  carouselSlide [dataMerge]="30" [width]="266" >
                        <div class="movie-card">
                        <div class="image">
                        <img [src]="'https://image.tmdb.org/t/p/w300'+slide.poster_path"/>
                      </div>
                      <h2 class="movie-title">{{slide.title}}</h2>
                      <div class="bar">
                        <span class="date">2021</span>
                        <span class="adult">+18</span>
                        <span class="date">Action</span>
                      </div>
                      <ul class="movie-icons">
                        <li><i class="fas fa-play"></i></li>
                        <li><i class="fas fa-plus"></i></li>
                        <li><i class="fas fa-info"></i></li>
                      </ul>
                    </div>

        </ng-template>
    </ng-container>
</owl-carousel-o>
